import React from 'react';

import logo from '../../assets/images/LOGO.png';
import bars from '../../assets/icons/bars-solid.svg';
import OpenClose from '../../components/OpenClose';

import {
	HeaderContainer,
	HeaderLogo,
	HeaderBrand,
	HeaderMainTitle,
	HeaderNavigation,
	HeaderNavigationButton,
	NavigationIcon,
	CheckBarsMenu,
	BarsMenuButton,
} from './styles';

const Header = ({ isOpen }) => {
	console.log(isOpen);
	return (
		<HeaderContainer>
			<CheckBarsMenu type='checkbox' id='check' name='check' />
			<NavigationIcon for='check'>
				<BarsMenuButton src={bars} />
			</NavigationIcon>
			<HeaderBrand>
				<HeaderLogo src={logo} />
				<HeaderMainTitle>
					<span>Ortopedia </span>EVOLUCIÓN
				</HeaderMainTitle>
			</HeaderBrand>
			<OpenClose value={isOpen ? 'ABIERTO' : 'CERRADO'} />
			<HeaderNavigation id='menu'>
				<HeaderNavigationButton href='#aboutus'>Nosotros</HeaderNavigationButton>
				<HeaderNavigationButton href='#productos' hasSeparators>
					Productos
				</HeaderNavigationButton>
				<HeaderNavigationButton href='#contact'>Contacto</HeaderNavigationButton>
			</HeaderNavigation>
		</HeaderContainer>
	);
};

export default Header;
